import { TournamentCompetition, TournamentSession } from "@mixitone/models";
import { mixitoneImagesTransformedUrl, withStateToggle } from "@mixitone/util";
import { PortalController } from "../../controllers/PortalController";

interface State {
  loading: boolean;
  portalSlug: string;
  bannerUrl?: string;
  tournament: TournamentSession | null;
  competitions: TournamentCompetition[];
}

interface Props {
  params: {
    portalSlug: string;
  };
}

export class TournamentPageController extends PortalController<State, Props> {
  get initialState(): State {
    return {
      loading: true,
      portalSlug: "",
      tournament: null,
      competitions: [],
    };
  }

  async initialize(props: Props) {
    this.state.portalSlug = props.params.portalSlug;
    await this.loadTournament();
  }

  /**
   * Called when props change, like when navigating to a different tournament
   */
  async changeProps(props: Props) {
    this.state.portalSlug = props.params.portalSlug;
    await this.loadTournament();
  }

  @withStateToggle("loading")
  private async loadTournament() {
    if (!this.state.portalSlug) return;

    try {
      const tournament = await TournamentSession.query()
        .eq("portal_slug", this.state.portalSlug)
        .eq("is_public", true)
        .first();

      if (tournament) {
        this.state.tournament = tournament;
        this.state.bannerUrl = this.getBannerUrl();
        if (tournament.isCompleted) {
          this.state.competitions = [];
        } else {
          this.state.competitions = await tournament.competitions.query.eq("status", "entry_open").all();
        }
      }
    } catch (error) {
      console.error("Error loading tournament:", error);
      // Leave tournament as null to show not found message
    }
  }

  getBannerUrl(): string | undefined {
    const imageId = this.state.tournament?.banner_image_id;
    if (!imageId) return undefined;

    const filePath = `${this.state.tournament?.account_id}/${imageId}`;
    return mixitoneImagesTransformedUrl(filePath, {
      width: 800,
      fit: "scale-down",
      format: "auto",
    });
  }
}
